export default __webpack_public_path__ + "static/media/erotic-mouth.6f5a932c.png";